import { useTranslation } from "react-i18next";
import {
  Alert,
  Body,
  Footer,
  Header,
  DevelopmentInfo,
  Navbar,
  useAlerts,
  useUsers,
} from "common";
import { navbar as navbarConfig } from "app/shared/config";
import { MainContainer } from "common/components/Main-Container/MainContainer";
import { LicenseInfo as MuiLicenseInfo } from "@mui/x-license";
import ReactGA from "react-ga4";
import { useNavBar } from "./shared/services/NavigationService/NavigationProvider";

export const App = () => {
  const { getMenuItems } = useNavBar();
  const { alert } = useAlerts();
  const { t } = useTranslation();
  const { loggedInUser, currentUser, accessDenied } = useUsers();

  MuiLicenseInfo.setLicenseKey(window.RUNTIME_CONFIG.muiLicenseKey);

  if (
    currentUser.isLoaded &&
    !accessDenied &&
    window.RUNTIME_CONFIG.gaMeasurementId
  ) {
    ReactGA.initialize(window.RUNTIME_CONFIG.gaMeasurementId);
  }

  return (
    <>
      <DevelopmentInfo />
      <Header
        logoTitle={t("app.logoTitle")}
        logoSubtitle={t("app.logoSubtitle")}
        userDisplayName={loggedInUser.displayName}
      />
      <Body>
        {currentUser.isLoaded ? (
          <>
            <Navbar menuItems={getMenuItems()} width={navbarConfig.width} />
            {alert.exists && <Alert />}
            <MainContainer idAttr="project-slug-main" />
          </>
        ) : (
          <>{alert.exists && <Alert />}</>
        )}
      </Body>
      <Footer
        copyrightYear={t("app.copyrightYear")}
        productVersion={
          window.RUNTIME_CONFIG.productVersion || process.env.REACT_APP_VERSION
        }
      />
    </>
  );
};
